export const customTenantCatalogueResponseMock = {
  VEHICLETYPE_PASSENGER_CAR: {
    makes: {
      MAKE_TRABANT: {
        models: {
          '007': {
            isCustom: true,
          },
        },
        isCustom: false,
      },
      sdf: {
        models: {
          dsdf: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      MAKE_AUSTIN_HEALEY: {
        models: {
          Unknown: {
            isCustom: true,
          },
        },
        isCustom: false,
      },
      MAKE_CATERHAM: {
        models: {
          Unknown: {
            isCustom: true,
          },
        },
        isCustom: false,
      },
      MAKE_DAEWOO: {
        models: {
          Unknown: {
            isCustom: true,
          },
        },
        isCustom: false,
      },
    },
  },
  VEHICLETYPE_SEMI_TRAILER: {
    makes: {
      Schmitz: {
        models: {
          'Gotha Ski': {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      qqq: {
        models: {
          qqq: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_TRAILER: {
    makes: {
      asdasf: {
        models: {
          sfsdfsdf: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      Lada: {
        models: {
          Priora: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      Privet: {
        models: {
          Poka: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_OTHER: {
    makes: {
      Yamaha: {
        models: {
          skuter: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      Zetor: {
        models: {
          Traktor: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_BUS: {
    makes: {
      Iveco: {
        models: {
          Sralis: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_VAN: {
    makes: {
      TEST: {
        models: {
          TEST2: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      MAKE_SKODA: {
        models: {
          aaa: {
            isCustom: true,
          },
        },
        isCustom: false,
      },
    },
  },
  VEHICLETYPE_AGRICULTURAL_MACHINE: {
    makes: {
      'John Deere': {
        models: {
          Other: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_MOTORCYCLE: {
    makes: {
      MAKE_BMW: {
        models: {
          Joker: {
            isCustom: true,
          },
        },
        isCustom: false,
      },
      Yamaha: {
        models: {
          'TZR 50': {
            isCustom: true,
          },
          skuter: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_CONSTRUCTION_MACHINE: {
    makes: {
      JCB: {
        models: {
          Ostatní: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
  VEHICLETYPE_TRUCK: {
    makes: {
      truck: {
        models: {
          truckovic: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      'truck ': {
        models: {
          truckovic: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      truck1: {
        models: {
          'truck model1': {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      'My Fabulous Ligma Truck': {
        models: {
          test: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      estzgh: {
        models: {
          Other: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
      MAKE_FORD: {
        models: {
          Ostatní: {
            isCustom: true,
          },
        },
        isCustom: false,
      },
      zzz: {
        models: {
          zzuu: {
            isCustom: true,
          },
        },
        isCustom: true,
      },
    },
  },
};
